import { typeUtils } from '@festina-life/core'
import { FormikForm, FormikTextInput } from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'
import * as Yup from 'yup'

import { READ_ONLY_WORKSPACE } from '../../system/constants'
import type { WorkspaceCreateOrUpdateInput } from '../../uiModels/workspace/types'
import { useExistentWorkspaceNames } from '../../uiModels/workspace/useExistentWorkspaceNames'

type Props = {
  initialValues: WorkspaceCreateOrUpdateInput
  onSubmit: (values: WorkspaceCreateOrUpdateInput) => void
  formId: string
}

export const WorkspaceForm = ({ initialValues, onSubmit, formId }: Props) => {
  const translate = useTranslate()
  const existentWorkspaceNames = useExistentWorkspaceNames(
    initialValues.branchKey.server,
  )

  const validationSchema = Yup.object({
    name: Yup.string()
      .required(translate('validation.required'))
      .min(3, translate('validation.length', { length: 3 }))
      .noSpaces(translate('validation.noSpaces'))
      .notForbidden(translate('validation.notForbidden'), [READ_ONLY_WORKSPACE])
      .notDuplicated(
        translate('validation.duplicated'),
        existentWorkspaceNames,
      ),
  })

  const validate = typeUtils.createValidator<WorkspaceCreateOrUpdateInput>()

  return (
    <FormikForm
      formId={formId}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      validateOnBlur={false}
    >
      {({ values, setFieldValue }) => {
        if (values.name.includes(' ')) {
          void setFieldValue('name', values.name.replace(/\s/g, '-'))
        }

        return (
          <div className="flex flex-col gap-x-2">
            <FormikTextInput
              isRequired
              name={validate('name')}
              label={translate('workspaceManager.form.name')}
            />
          </div>
        )
      }}
    </FormikForm>
  )
}
